import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { useState } from 'react';

import { useAppDispatch } from 'store';
import { resetForm } from 'store/intakeForm/intakeFormThunks';

export const ResetFormDialog = () => {
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button label="Reset" id="reset-form-button" onClick={() => setIsOpen(true)} />
            <WarningDialog
                isOpen={isOpen}
                dialogTitle="Reset"
                dialogContent={<p>Are you sure you want to reset the intake form?</p>}
                primaryButtonLabel="Reset"
                primaryButtonIntent={Button.Intent.DANGER}
                secondaryButtonLabel="Cancel"
                onPrimaryButtonClick={() => {
                    dispatch(resetForm());
                    setIsOpen(false);
                }}
                onSecondaryButtonClick={() => setIsOpen(false)}
            />
        </>
    );
};
